// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"b8baf62d","347":"e070e917","370":"93fca4eb","431":"dacb0f78","520":"411bd64c","641":"740b8c02","648":"12c82279","770":"5cb0ae1c","874":"c1d833ba"}[chunkId] + ".chunk.js";
};